/* eslint-disable no-undef */
import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
	server: {
		CENTRA_CHECKOUT_SECRET: z.string().min(1),
		PREVIEW_TOKEN: z.string().min(1),
		REVALIDATE_SECRET: z.string().min(1),
		STORYBLOK_TOKEN: z.string().min(1),
		STORYBLOK_SPACE_ID: z.string().min(1),
		KLAVIYO_API_KEY: z.string().min(1),
		CENTRA_INTEGRATION_TOKEN: z.string().min(1),
		CENTRA_INTEGRATION_URL: z.string().url(),
		REVALIDATE_WORKER_BASE_URL: z.string().url(),
		WITHDRAWAL_NOTIFICATION_EMAIL: z.string().email(),
		AUTH_SECRET: z.string().min(1).optional(),
		DASHBOARD_EMAIL: z.string().email().optional(),
		DASHBOARD_PASSWORD: z.string().min(1).optional(),
	},
	client: {
		NEXT_PUBLIC_CENTRA_CHECKOUT: z.string().url(),
		NEXT_PUBLIC_CENTRA_DOMAIN: z.string().min(1),
		NEXT_PUBLIC_GTM_ID: z.string().min(1),
		NEXT_PUBLIC_PROJECT: z.string().min(1),
		NEXT_PUBLIC_HYPERDX_KEY: z.string().min(1),
		NEXT_PUBLIC_MAPBOX_STYLE_URL: z.string().min(1),
		NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN: z.string().min(1),
		NEXT_PUBLIC_HUBSPOT_PORTAL: z.string().min(1),
		NEXT_PUBLIC_KLAVIYO_ACCOUNT_ID: z.string().min(1),
	},
	experimental__runtimeEnv: {
		NEXT_PUBLIC_CENTRA_CHECKOUT: process.env.NEXT_PUBLIC_CENTRA_CHECKOUT,
		NEXT_PUBLIC_CENTRA_DOMAIN: process.env.NEXT_PUBLIC_CENTRA_DOMAIN,
		NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
		NEXT_PUBLIC_PROJECT: process.env.NEXT_PUBLIC_PROJECT,
		NEXT_PUBLIC_HYPERDX_KEY: process.env.NEXT_PUBLIC_HYPERDX_KEY,
		NEXT_PUBLIC_MAPBOX_STYLE_URL: process.env.NEXT_PUBLIC_MAPBOX_STYLE_URL,
		NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN:
			process.env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN,
		NEXT_PUBLIC_HUBSPOT_PORTAL: process.env.NEXT_PUBLIC_HUBSPOT_PORTAL,
		NEXT_PUBLIC_KLAVIYO_ACCOUNT_ID: process.env.NEXT_PUBLIC_KLAVIYO_ACCOUNT_ID,
	},
	onValidationError: (error) => {
		console.error(error);
		throw new Error(`Invalid envorinment: ${JSON.stringify(error, null, 2)}`);
	},
});
